import React from 'react';

import { getErrorMessage } from '~libs/axiosWrapper';

import { ErrorResponse, Spinner } from '~components';
import { TableView } from '~components/table-view';

import { sahReferenceDataColumns } from '~support-at-home/forms/reference-data/sahReferenceDataColumns';

import { useGetSahReferenceDataQuery } from '~support-at-home/actions/sahReferenceData';

const SahReferenceDataManager: React.FC = () => {
  const { data, isLoading, isError, error } = useGetSahReferenceDataQuery();

  if (isLoading) return <Spinner loading className="p-5" />;
  if (isError) return <ErrorResponse message={getErrorMessage(error)} />;

  const rows = data ?? [];

  return (
    <div data-cy="sah-reference-data">
      {/* This tab shows the GLOBAL Services Australia reference lists (shared by every provider) —
          distinct from the per-client "SaH Approved Services" config tab, which manages which
          services are associated to an individual client. Easy to conflate by name; they are not
          the same data. */}
      <p className="text-muted">
        Global Services Australia reference lists shared by all providers. This is not the per-client SaH Approved
        Services list.
      </p>
      <TableView
        id="sah-reference-data"
        data={rows}
        columns={sahReferenceDataColumns}
        readonly
        compactView
        bordered
        emptyMessage="No reference data lists found"
      />
    </div>
  );
};

export default SahReferenceDataManager;
